import Steel904L from "../assets/Steel904L.png";
import gold from "../assets/gold.png";
import platinum from "../assets/platinum.png";
import roseGold from "../assets/rose-gold.png";
import Carousel from "./Carousel";

export default function NFTCarousel() {
  return (
    <Carousel>
      <img
        src={Steel904L}
        className="rounded-md max-h-96 max-w-96"
        alt="Steel 904L"
      />
      <img
        src={gold}
        className="rounded-md max-h-96 max-w-96"
        alt="Gold Au750"
      />
      <img
        src={roseGold}
        className="rounded-md max-h-96 max-w-96"
        alt="Rose Gold Au750Cu"
      />
      <img
        src={platinum}
        className="rounded-md max-h-96 max-w-96"
        alt="Platinum Pt950"
      />
    </Carousel>
  );
}
